module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "loader"
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.loading')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2ed16b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/Loading.vue
// module id = 924
// module chunks = 1